var _defs, _circle, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIkonyKanapka(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    "data-name": "Warstwa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 571.57 571.57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #1d1d1b;\n      }\n\n      .cls-1, .cls-2 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #d78017;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 226.2,
    cy: 248.78,
    r: 112.81
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M435.8,234.21c-20.67-51.41-71.04-87.79-129.75-87.79s-109.09,36.38-129.76,87.79c-2.26,5.61-4.16,11.41-5.68,17.35h270.87c-1.52-5.94-3.43-11.74-5.68-17.35ZM195.22,234.21c19.58-41.59,61.9-70.44,110.83-70.44s91.24,28.85,110.82,70.44h-221.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M170.61,349.08c1.52,5.94,3.43,11.74,5.68,17.35,8.02,19.95,20.51,37.64,36.23,51.81,7.3,6.59,15.29,12.41,23.85,17.35h139.34c8.56-4.95,16.56-10.77,23.85-17.35,15.72-14.17,28.22-31.85,36.24-51.81,2.26-5.61,4.16-11.41,5.68-17.35H170.61ZM370.89,418.24h-129.7c-19.87-12.45-35.92-30.45-45.98-51.81h221.65c-10.06,21.36-26.11,39.36-45.98,51.81Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 153.92,
    y: 316.63,
    width: 304.25,
    height: 17.35
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M171.44,295.51c18.48,4.51,38.64,4.93,56.74-1.43,4.38-1.54,8.63-3.41,12.91-5.22-.69.29-1.38.58-2.07.87,6.99-2.95,14.08-5.53,21.62-6.56-.77.1-1.54.21-2.31.31,4.48-.59,8.99-.63,13.47-.03-.77-.1-1.54-.21-2.31-.31,5.48.76,10.72,2.47,15.8,4.6-.69-.29-1.38-.58-2.07-.87,10.6,4.49,20.7,10.35,32.02,12.91,15,3.39,31.11,1.74,45.31-4.06,7.09-2.89,13.73-6.7,20.77-9.69-.69.29-1.38.58-2.07.87,4.31-1.81,8.77-3.12,13.4-3.75-.77.1-1.54.21-2.31.31,5.34-.69,10.74-.54,16.07.16-.77-.1-1.54-.21-2.31-.31,6.65.91,13.11,2.73,19.3,5.32-.69-.29-1.38-.58-2.07-.87,4.38,1.86,8.59,4.07,12.63,6.58,3.86,2.4,9.72.96,11.87-3.11,2.25-4.25,1.01-9.31-3.11-11.87-11.24-6.97-23.64-11.52-36.78-13.15-6.89-.85-13.79-.65-20.62.65-5.47,1.04-10.65,3.14-15.68,5.49-5.01,2.34-9.86,5.01-14.95,7.17.69-.29,1.38-.58,2.07-.87-6.14,2.57-12.53,4.32-19.12,5.24l2.31-.31c-5.66.75-11.38.86-17.05.12.77.1,1.54.21,2.31.31-6.36-.86-12.47-2.79-18.37-5.28.69.29,1.38.58,2.07.87-8.79-3.74-17.19-8.49-26.36-11.31-11.16-3.43-22.96-3.3-34.21-.31-6.34,1.68-12.34,4.34-18.37,6.88.69-.29,1.38-.58,2.07-.87-7.7,3.25-15.48,5.92-23.8,7.06.77-.1,1.54-.21,2.31-.31-8.48,1.11-17.1.98-25.57-.14.77.1,1.54.21,2.31.31-3.78-.51-7.53-1.23-11.24-2.13-4.4-1.08-9.61,1.4-10.67,6.06-1.02,4.47,1.34,9.52,6.06,10.67h0Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 257.92,
    cy: 194.7,
    r: 7.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 245.18,
    cy: 216.4,
    r: 7.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 270.66,
    cy: 216.4,
    r: 7.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIkonyKanapka);
export default __webpack_public_path__ + "static/media/ikony_kanapka.7c595aa0bf753701652546037a184590.svg";
export { ForwardRef as ReactComponent };